import { Page, ReviewModel } from '../../typings/reviews';
import { AppConstants } from '../../utils/app-constants';

/**
 * Parses reviews data according to reverse state
 * @param data
 * @param reverse
 * @returns
 */
export const parseReviewsData = (
  data: ReviewModel | undefined,
  reverse?: boolean,
) => {
  if (!data) return undefined;
  return reverse ? { ...data, reviews: data.reviews.reverse() } : data;
};

/**
 * Parses page data according to reverse state
 * @param page
 * @param reverse
 * @returns
 */
export const parsePageData = (page: Page, reverse?: boolean): Page => {
  // let { totalPages, number, totalElements } = page;
  let newPage = page;
  // debugger
  // if (reverse) {
  //   let reversePageAmount: number | undefined = undefined;
  //   let reversePageNumber: number | undefined = undefined;
  //   if(number > AppConstants.API_PAGINATION_BASE && number < totalPages){
  //       reversePageNumber = number - 1; // mod base number
  //       if (reversePageNumber > 0) {
  //         let isFloorNumber = reversePageNumber <= (totalPages / 2);
  //         reversePageNumber = isFloorNumber ? totalPages - reversePageNumber: totalPages % reversePageNumber;
  //       } else {
  //         reversePageNumber = 1;
  //       }
  //   } else {
  //       reversePageNumber = number === totalPages ? 1 : totalPages
  //   }
  //   reversePageAmount = totalElements % AppConstants.ALL_REVIEWS_SIZE;
  //   reversePageAmount = reversePageAmount || AppConstants.ALL_REVIEWS_SIZE;
  //   newPage = {
  //     ...page,
  //     number: reversePageNumber,
  //     pageElements: reversePageAmount,
  //   };
  // }

  return newPage;
};

/**
 * Get next page to call
 * @param pageNumber
 * @param page
 */
export const getNextPage = (
  pageNumber: number,
  totalPages: number,
  reverse?: boolean,
) => {
  let nextPageNumber = reverse ? pageNumber - 1 : pageNumber + 1;
  if (
    nextPageNumber >= AppConstants.API_PAGINATION_BASE &&
    nextPageNumber <= totalPages
  ) {
    return nextPageNumber;
  }
  return undefined;
};

/**
 * Get next page to call
 * @param pageNumber
 * @param page
 */
export const validatePage = (
  pageNumber: number,
  totalPages: number,
  isPrevious?: boolean,
) => {
  let nextPageNumber = isPrevious ? pageNumber - 1 : pageNumber + 1;
  if (
    nextPageNumber >= AppConstants.API_PAGINATION_BASE &&
    nextPageNumber <= totalPages
  ) {
    return nextPageNumber;
  }
  return undefined;
};

/**
 * Truncates reviews array with offset
 * @param reviews
 * @param offset
 * @returns
 */
export const truncateReviews = (
  reviews: ReviewModel | undefined,
  offset: number,
) => {
  if (!reviews) return undefined;
  if (reviews.reviews.length > offset) {
    return { ...reviews, reviews: reviews.reviews.slice(0, offset) };
  }
  return reviews;
};
